import React, { useState } from 'react';
import { Segment } from 'semantic-ui-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import * as constants from '../emails.constants';
import EmailsCampaignToolbar from './EmailsCampaignToolbar';
import EmailsTable from './EmailsTable';
import tracker from '../../../common/utils/tracking/tracker';
import * as trackerConstants from '../../../common/utils/tracking/tracking.consts';
import * as activityConstants from '../../Activity/activity.constants';
import * as appConstants from '../../App/app.constants';
import ConfirmationModal from '../../../common/components/CustomModal/ConfirmationModal/ConfirmationModal';

const EmailsCampaign = (props) => {
  const { key, emailMoveTo, campaign, campaignIndex, createEmail, updateCampaign, locationId,
    handleOnBlur, hasBasicPlanPermissions, businessBundlePlan, openToast, userAccessGroups, goToEmail,
    updateEmailStatus, openEmailInNewTab, hasFullPermission, transformedMentions, pinCampaign, focus } = props;
  const [promptAutoUnarchiveCampaignModalOpen, setPromptAutoUnarchiveCampaignModalOpen] = useState(false);
  const { formatMessage } = props.intl;
  const [email, setEmail] = useState(null);

  const handleGoToEmail = (hubId) => {
    const userHasAccessGroups = userAccessGroups && userAccessGroups.size > 0;
    const selectedEmail = campaign.get(constants.EMAILS).find((e) => e.get(activityConstants.HUB_ID) === hubId);
    const isAccessGroupEnabled = hasFullPermission(appConstants.FEATURES_ACCESS_GROUPS);

    if (isAccessGroupEnabled && !selectedEmail.get(activityConstants.ACCESS_GROUP_IDS) && userHasAccessGroups) {
      return;
    }

    const relatedCampaignId = campaign.get(constants.CAMPAIGN_ID);
    goToEmail(hubId, relatedCampaignId);
  };

  const handleChangeEmailStatus = (e) => {
    const newEmailStatus = e.get(constants.STATUS);
    const currentCampaignStatus = campaign.get(constants.CAMPAIGN_STATUS);
    if (newEmailStatus === activityConstants.ACTIVITY_STATUS_ACTIVE &&
      currentCampaignStatus !== constants.CAMPAIGN_STATUS_ACTIVE) {
      setPromptAutoUnarchiveCampaignModalOpen(true);
      setEmail(e);
    } else {
      updateEmailStatus(e);
    }
  };

  const handleOnConfirmAutoUnarchive = () => {
    updateEmailStatus(email);
    setEmail(null);
    setPromptAutoUnarchiveCampaignModalOpen(false);
  };

  const isFocusedClass = classNames('campaign', {
    'campaignFocused': focus,
    'listViewArchive': campaign.get(constants.CAMPAIGN_STATUS) === constants.CAMPAIGN_STATUS_ARCHIVE,
    'pinned': campaign.get(constants.CAMPAIGN_PINNED_DATE),
  });

  const emails = campaign.get(constants.EMAILS);

  return (
    <Segment
      className={isFocusedClass}
      loading={campaign.get(constants.CAMPAIGN_ID) === -1}
    >
      { campaign.get(constants.CAMPAIGN_STATUS) === constants.CAMPAIGN_STATUS_ARCHIVE && (
        <i className="archivedCampaign como-svg-icon-archivedShape">
          <span className="archivedText">{formatMessage({ id: 'business-center.campaign.activity.status.archived' })}</span>
        </i>
      )}
      <ConfirmationModal
        open={promptAutoUnarchiveCampaignModalOpen}
        onConfirm={handleOnConfirmAutoUnarchive}
        onCancel={() => setPromptAutoUnarchiveCampaignModalOpen(false)}
      >
        {formatMessage({ id: 'business-center.campaign.archive.confirmation.content' })}
      </ConfirmationModal>
      <EmailsCampaignToolbar
        focus={focus}
        handleOnBlur={handleOnBlur}
        campaignIndex={campaignIndex}
        campaign={campaign}
        locationId={locationId}
        createEmail={tracker.wrapButtonAction(
          createEmail,
          trackerConstants.BUTTON_TYPE_EMAIL_CREATE)
        }
        updateCampaign={updateCampaign}
        hasBasicPlanPermissions={hasBasicPlanPermissions}
        businessBundlePlan={businessBundlePlan}
        openToast={openToast}
        userAccessGroups={userAccessGroups}
        pinCampaign={pinCampaign}
        hasFullPermission={hasFullPermission}
      />
      {emails && emails.size > 0 &&
        <EmailsTable
          emailMoveTo={emailMoveTo}
          changeActivityStatus={handleChangeEmailStatus}
          emails={emails}
          goToEmail={handleGoToEmail}
          openEmailInNewTab={openEmailInNewTab}
          transformedMentions={transformedMentions}
          hasFullPermission={hasFullPermission}
          userAccessGroups={userAccessGroups}
          hasBasicPlanPermissions={hasBasicPlanPermissions}
          businessBundlePlan={businessBundlePlan}
        />
      }
    </Segment>
  );
};

EmailsCampaign.propTypes = {
  key: PropTypes.string,
  intl: PropTypes.object,
  emailMoveTo: PropTypes.func.isRequired,
  campaign: PropTypes.object.isRequired,
  campaignIndex: PropTypes.number.isRequired,
  createEmail: PropTypes.func.isRequired,
  updateCampaign: PropTypes.func.isRequired,
  locationId: PropTypes.number.isRequired,
  handleOnBlur: PropTypes.func,
  hasBasicPlanPermissions: PropTypes.bool,
  businessBundlePlan: PropTypes.string,
  openToast: PropTypes.func,
  userAccessGroups: PropTypes.object,
  updateEmailStatus: PropTypes.func,
  openEmailInNewTab: PropTypes.func.isRequired,
  goToEmail: PropTypes.func.isRequired,
  hasFullPermission: PropTypes.func.isRequired,
  transformedMentions: PropTypes.object,
  pinCampaign: PropTypes.func,
  focus: PropTypes.bool.isRequired
};

export default injectIntl(EmailsCampaign);
